module.exports = __webpack_public_path__ + "static/media/The Trap.edc969c5.jpg";